import { Box, Grid } from '@mui/material';
import React, { useState } from 'react';
import Details from './details-dialog';
import './project.scss';

const Project = ({project}) => {

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

    const {
      name,
      thumb6,
      thumb2,
      thumb3,
      thumb4,
      thumb5,
      technology,
      desc,
      liveSite,
      clientCode,
      serverCode,
    } = project;

    return (
      <Grid sx={{ m: 1 }} item>
        <div className="project-container">
          <Box sx={{ background: `url(${thumb6})` }} className="box">
            <div className="color-overlay">
              {liveSite && <div className="text-center">
                <a
                  href={liveSite}
                  target="blank"
                  className="text-decoration-none  "
                >
                  <button className="primary-btn rounded-full font-semibold mt-3 px-1">
                    Live
                  </button>
                </a>
              </div>}
              <div className="text-center">
                <button
                  onClick={handleClickOpen}
                  className="primary-btn mt-3 px-1 rounded-full font-semibold"
                >
                  Details
                </button>
              </div>
            </div>
          </Box>
        </div>
        <Details
          setOpen={setOpen}
          open={open}
          handleClose={handleClose}
          name={name}
          technology={technology}
          desc={desc}
          clientCode={clientCode}
          serverCode={serverCode}
          liveSite={liveSite}
        />
      </Grid>
    );
};

export default Project;